/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {ApiKeyListPageComponent} from './api-key-list-page.component';

@Component({
  standalone: true,
  imports: [ApiKeyListPageComponent],
  selector: 'adn-api-key-route-page',
  template: `
    <adn-api-key-list-page [readOnly]="readOnly"></adn-api-key-list-page>
  `
})
export class ApiKeyRoutePageComponent {
  @Input() readOnly = false;
}
